var SENTRY_RELEASE;SENTRY_RELEASE={name: "BraveBrain (Staging)", version: "1.1.1"};